<template>
    <div class="entry-times-page">
        <h4>Tiempos máximos de ingreso de los visitantes</h4>
        <div class="col-12 col-sm-6 m-sm-auto">
            <div class="row">
                <div class="col-12">
                    <app-form-select-input label="Cliente" :options="clients" v-model="clientId" :hasError="$v.clientId.$error" errorMessage="Primero debe seleccionar un cliente" @change="loadTimes" />
                </div>
            </div>
            <div class="row" v-if="!!clientSearched">
                <div class="col-12">
                    <table class="table table-sm table-hover table-bordered table-striped">
                        <thead class="thead-orange">
                            <tr>
                                <th colspan="2">
                                    {{ clientName }}
                                </th>
                            </tr>
                            <tr>
                                <th>Tipo de visitante</th>
                                <th>Tiempo máximo en minutos
                                    <br>
                                    <small>(si no tiene tiempo máximo poner un cero)</small>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="type in visitorTypes">
                                <td>{{ type.name }}</td>
                                <td>
                                    <input type="number" v-model="times[type.id]" class="form-control col-6">
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2">
                                    <button class="btn btn-confirm pull-right" @click="saveTimes">
                                        <i class="fa fa-save"></i> Guardar</button>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import vigilanceRepository from '../../../../repositories/vigilance.repository';
    import clientRepository from '../../../../repositories/clients.repository';
    import FormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue';
    import { required } from 'vuelidate/lib/validators';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            appFormSelectInput: FormSelectInput
        },
        data() {
            return {
                visitorTypes: [],
                times: {},
                clientId: '',
                clientSearched: false
            }
        },
        validations: {
            clientId: { required }
        },
        methods: {
            loadVisitorTypes() {
                vigilanceRepository.getVisitorTypes()
                    .then(data => {
                        this.visitorTypes = data;

                    })
                    .catch(error => toastr.error('Ocurrió un error al cargar los tipos de visitantes'));
            },
            loadTimes() {
                // Validar que si se halla seleccionado un cliente
                this.$v.$touch();
                if(this.$v.$invalid) return this.clientSearched =false;

                this.clientSearched = true;
                
                clientRepository.getClientEntryTimes(this.clientId)
                    .then(data => {
                        let times = {};
                        data.map(item => times[item.visitor_type_id] = item.max_time);
                        this.times = times;
                    })
                    .catch(error => toastr.error('Ocurrió un error al cargar los tiempos del cliente'));
            },
            setTime(visitoTypeId, maxTime) {
                const timeObj = {
                    visitorTypeId,
                    maxTime
                }
                const index = this.times.findIndex(item => item.visitorTypeId === typeId);
                if (index != -1) {
                    this.times.splice(index, 1, timeObj);
                } else {
                    this.times.push(timeObj);
                }
            },
            saveTimes() {
                const payload = {
                    userId: this.user.id,
                    clientId: this.clientId,
                    times: this.times
                }
                clientRepository.saveEntryTimes(payload)
                    .then(data => {
                        toastr.success('Los tiempos de ingreso fueron guardados satisfactoriamente');
                    })
                    .catch(error => toastr.error('Ocurrió un error'));

            },
        },
        computed: {
            ...mapGetters(['clients']),
            clientName(){
                return !!this.clientId? this.clients.find(item => item.id === parseInt(this.clientId)).name: '';
            }  
        },
        created() {
            this.loadVisitorTypes();
            this.load('clients');
        }
    }
</script>